import React, { useContext, useEffect, useState } from "react"

import AuthContext, { AuthContextInterface } from "../contexts/AuthContext"

const useGetUserAndRole = () => {
  const { accessToken }: AuthContextInterface = useContext(AuthContext)

  const [userRole, setUserRole] = useState<string[]>([])
  const [userDetails, setUserDetails] = useState<string[]>([])

  const getParsedJwt = <T extends object = { [k: string]: string | number }>(token: string): T | undefined => {
    try {
      return JSON.parse(atob(token.split(".")[1]))
    } catch {
      return undefined
    }
  }

  // onMount -> get the token from the JWT and parse for the role
  useEffect(() => {
    if (!accessToken) {
      setUserRole([])
      setUserDetails([])
      return
    }
    const jwt: any = getParsedJwt(accessToken)
    setUserRole(jwt.role)
    setUserDetails(jwt)
  }, [accessToken])

  return [userRole, userDetails]
}

export default useGetUserAndRole
